module.exports = __webpack_public_path__ + "img/1.d5f11d21.png";